export default [
  {
    path: '/suivi-instantane',
    name: 'suivi-instantane',
    component: () => import('@/views/SuiviInstantane.vue'),
    meta: {
      layout: 'vertical',
      requireLogin: true,
      pageTitle: 'Suivi Colis Instantané',
      breadcrumb: [
        {
          text: 'Suivi Instantané',
          active: true,
        },
      ],
    },
  },
]
